import { createStyles } from "@mantine/styles";

export const useStyles = createStyles((theme) => ({
  container: {
    flex: 1,
    padding: theme.spacing.xl,
    backgroundColor: theme.colors.gray[1],
    minWidth: 300,
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      padding: theme.spacing.md,
      minWidth: "unset",
    },
  },
  sectionLabel: {
    marginBottom: theme.spacing.xs,
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      marginLeft: theme.spacing.xs,
      fontSize: theme.fontSizes.sm,
    },
  },
  continuedLabel: {
    marginBottom: theme.spacing.xs,
    marginLeft: "20%",
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      marginLeft: theme.spacing.md,
      fontSize: theme.fontSizes.sm,
    },
  },
  paper: {
    width: "100%",
    maxWidth: "12.5in",
    minHeight: "11in",
    margin: `${theme.spacing.xl} auto`,
    padding: "0.5in",
    boxSizing: "border-box",
    pageBreakAfter: "always",
    fontFamily: "var(--big-font)",
    transition: "all 0.3s ease-in-out",
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      width: "100%",
      minHeight: "auto",
      margin: `${theme.spacing.md} 0`,
      padding: theme.spacing.md,
    },
  },
  emptyPaper: {
    width: "100%",
    maxWidth: "12.5in",
    minHeight: "11in",
    margin: `${theme.spacing.xl} auto`,
    padding: "1in",
    boxSizing: "border-box",
    pageBreakAfter: "always",
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      width: "100%",
      minHeight: "auto",
      margin: `${theme.spacing.md} 0`,
      padding: theme.spacing.md,
    },
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)", // Default for large screens
    "@container (max-width: 1200px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: theme.spacing.sm,
    },
    "@container (max-width: 900px)": {
      gridTemplateColumns: "1fr",
      gap: theme.spacing.xs,
    },
    // Fluid gap adjustment
    gap: "clamp(0.5rem, 1.5vw, 1rem)",
    [`@media (max-width: 1200px)`]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    [`@media (max-width: 900px)`]: {
      gridTemplateColumns: "1fr",
      gap: theme.spacing.sm,
    },
  },

  label: {
    gridColumn: "1 / -1",
    borderRadius: theme.radius.md,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.sm,
    padding: "clamp(0.5rem, 1vw, 1rem)",
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      fontSize: theme.fontSizes.sm,
    },
  },
  field: {
    lineHeight: 1.5,
    fontSize: "clamp(0.875rem, 1.2cqw, 1.1rem)",
    minWidth: "150px",
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      fontSize: "0.875rem",
    },
  },
  document: {
    lineHeight: 1.5,
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      fontSize: theme.fontSizes.sm,
    },
  },
  italicText: {
    fontStyle: "italic",
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      fontSize: theme.fontSizes.sm,
    },
  },
  fieldHeader: {
    backgroundColor: theme.colors.blue[0],
    display: "flex",
    padding: theme.spacing.md,
    paddingLeft: theme.spacing.lg,
    marginBottom: theme.spacing.sm,
    borderRadius: theme.radius.md,
    flexWrap: "wrap",
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      padding: theme.spacing.sm,
      paddingLeft: theme.spacing.md,
      fontSize: theme.fontSizes.sm,
    },
  },
  interactiveItem: {
    minHeight: 48,
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
      minHeight: 40,
    },
  },
  resizeHandle: {
    marginTop: 45,
    position: "absolute",
    right: -5, // Extend beyond the column boundary
    top: 0,
    bottom: 0,
    width: "10px", // Wider invisible hit area
    cursor: "col-resize",
    "&:hover::after, &:active::after": {
      backgroundColor: theme.colors.blue[6],
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: "4px",
      top: 0,
      bottom: 0,
      width: "2px",
      backgroundColor: theme.colors.gray[4],
      transition: "background-color 150ms ease",
    },
  },
  resizeOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    cursor: "col-resize",
    zIndex: 9999,
    // Prevent any pointer events on content below
    pointerEvents: "none",
    // Force hardware acceleration
    transform: "translateZ(0)",
  },
}));
